/* rb-m-coll.js -- collection pages. Phone only, needs window.RBM.
   What the CSS cannot do: count the active filters onto the sticky bar, put
   Size first in the filter panel, add quick-filter chips to the bar, pin the
   panel's actions, keep a running product total, replace the pager with Load
   more, count the swatches that do not fit on a card, and collapse the SEO
   block without taking it out of the DOM. */
(function () {
  'use strict';
  if (!window.RBM) return;

  /* ---- active filter count on the sticky bar --------------------------------
     A bar that says "Filter and sort" forever gives no sign that the 688
     products have been narrowed to 41, and on a page this long the applied
     filters scroll out of sight immediately.

     The count is read from the theme's own active-filter list rather than
     from the URL: the theme renders one element per applied value, so the
     number always matches what the page is actually showing, including any
     filter applied server-side that the URL does not spell out. */
  function countActive() {
    var box = document.querySelector('.collection__filters-active');
    if (!box) return 0;
    var tags = box.querySelectorAll('a, button, li');
    var n = 0;
    Array.prototype.forEach.call(tags, function (t) {
      var txt = (t.textContent || '').trim().toLowerCase();
      if (!txt || txt.indexOf('clear') === 0) return;   /* "Clear all" is not a filter */
      n++;
    });
    return n;
  }

  function paintCount() {
    var btn = document.querySelector('.collection-main__filter-btn');
    if (!btn) return;
    var n = countActive();

    /* The active-filter block is hidden by default in CSS because the theme
       renders it empty-but-spaced on every collection page -- ~160px of white
       around a "CLEAR ALL" that has nothing to clear. It comes back the
       moment there is something in it. */
    var box = document.querySelector('.collection__filters-active');
    if (box) box.classList[n ? 'add' : 'remove']('rbm-on');

    var badge = btn.querySelector('.rbm-filter-count');
    if (!n) { if (badge) badge.parentNode.removeChild(badge); return; }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'rbm-filter-count';
      btn.appendChild(badge);
    }
    badge.textContent = n;
    btn.setAttribute('aria-label', 'Filter and sort, ' + n + ' filter' + (n === 1 ? '' : 's') + ' applied');
  }

  RBM.onMobile('coll-count', function () {
    if (!document.querySelector('.collection-main__filter-btn')) return;
    paintCount();
    /* The grid re-renders on every filter change (the form is
       submit-on-change), so the count has to be repainted, not just set.
       onSectionSwap takes an ELEMENT, not a selector. */
    var grid = document.querySelector('.collection-products');
    if (grid && RBM.onSectionSwap) RBM.onSectionSwap(grid, paintCount);
  });

  /* ---- filter panel: size first, actions pinned -----------------------------
     Two changes, both about what a phone buyer reaches for.

     SIZE GOES FIRST. The panel renders Brand, Product type, Size, Price. On
     a phone the first question is almost always "what fits me" -- brand and
     product type are browsing filters, size is a buying filter. The groups
     live in .accordion-group--filter-order, so this is a reorder, not a
     rebuild, and the theme's own accordion behaviour comes with it.

     THE ACTIONS GET PINNED. "Clear all" and "View (688)" sit at the bottom
     of a long scroll, so applying a filter means scrolling back past
     everything you just set. The earlier CSS guessed at
     .collection-sidebar__footer, which does not exist -- the real row is an
     .o-layout--small holding two half-width items. Rather than key off that
     (o-layout is generic and has already caused one bad bug on this page),
     the row is found via the View button and tagged. */
  var panelState = { tracking: false, open: {} };
  RBM.onMobile('coll-panel', function () {
    var side = document.querySelector('.collection-sidebar');
    if (!side || side.dataset.rbmPanel === '1') return;

    var view = Array.prototype.filter.call(
      side.querySelectorAll('a.c-btn, button.c-btn'), function (b) {
        return /^view\s*\(/i.test((b.textContent || '').trim());
      })[0];
    if (view) {
      var row = view.closest('.o-layout');
      if (row) row.classList.add('rbm-panel-foot');
    }

    var order = side.querySelector('.accordion-group--filter-order');
    if (order) {
      var groups = order.querySelectorAll('.collection-sidebar__filter-group');
      var size = Array.prototype.filter.call(groups, function (g) {
        var head = g.querySelector('summary, h3, h4, button, [class*="heading"]');
        return /^size\b/i.test((head ? head.textContent : '').trim());
      })[0];
      if (size && groups.length) {
        /* MOVING THE NODE IS NOT ENOUGH. .accordion-group--filter-order is a
           flex column and every group carries an explicit CSS order (Brand 1,
           Product type 2, Size 3, Price 4), so a DOM move changed the tab
           order and nothing else on screen. The visual order has to be set
           as a property -- inline with priority, because the theme's value
           is a stylesheet rule this cannot otherwise outrank. The node move
           stays so that focus order and paint order agree. */
        if (size !== groups[0]) order.insertBefore(size, groups[0]);
        size.style.setProperty('order', '0', 'important');
      }
    }

    /* RESET ON CLOSE: Size open, everything else shut (Mark, 15 Sep). The
       theme remembers whatever you expanded, so after a look at Brand the
       panel reopens with Brand still hanging open and Size pushed down.
       Resetting when the panel CLOSES (the theme drops
       .js-collection-draw-open from <body>) means every open starts from the
       same place, and it cannot race the quick-filter chips, which open
       their group AFTER the panel is up. */
    var wasOpen = document.body.classList.contains('js-collection-draw-open');
    function groupName(g) {
      var head = g.querySelector('summary');
      return (head ? head.textContent : '').trim().toLowerCase();
    }
    function resetGroups() {
      /* document, not `side`: this closure outlives the panel it was made in */
      var gs = document.querySelectorAll('.collection-sidebar .collection-sidebar__filter-group');
      Array.prototype.forEach.call(gs, function (g) { g.open = /^size\b/.test(groupName(g)); });
      /* and forget the brand search, so the list is whole next time */
      var bg = brandGroup(), bi = bg && bg.querySelector('.rbm-find__in');
      if (bi) { brandQuery = ''; bi.value = ''; applyBrandFind(bg); }
    }
    if (!panelState.tracking) {
      /* remember what is open, so a re-render (every tick swaps the whole
         panel) can put it back -- otherwise ticking a brand snapped the Brand
         group shut and dropped you at the top of Size */
      panelState.tracking = true;
      document.addEventListener('toggle', function (e) {
        var g = e.target && e.target.closest && e.target.closest('.collection-sidebar__filter-group');
        if (g) panelState.open[groupName(g)] = !!g.open;
      }, true);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          var open = document.body.classList.contains('js-collection-draw-open');
          if (wasOpen && !open) { resetGroups(); panelState.open = {}; }
          wasOpen = open;
        }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
      resetGroups();
    } else {
      /* re-render: restore, Size open by default */
      Array.prototype.forEach.call(side.querySelectorAll('.collection-sidebar__filter-group'), function (g) {
        var n = groupName(g);
        g.open = (n in panelState.open) ? panelState.open[n] : /^size\b/.test(n);
      });
    }

    side.dataset.rbmPanel = '1';
  });

  /* ---- make the bar actually pin --------------------------------------------
     IT NEVER STUCK. position:sticky was on .collection-main__filter, whose
     parent .collection-main__actions is 94px tall -- a sticky element cannot
     travel outside its own containing block, so it held for about 30px and
     then scrolled away with the page. Measured at y=1600: bar top -1190. The
     computed style said "sticky" the whole time, which is exactly why
     checking the property instead of the behaviour missed it.

     So the parent is what pins, and the count line is lifted out of it first
     so the pinned element is the 63px row rather than a 94px block.

     TOP IS DRIVEN BY THE HEADER, NOT BY A CONSTANT. The theme's header is
     itself sticky and toggles between pinned and released with body classes
     whose meaning is not obvious (at y=1600 the body reads "header-up
     header-stuck" while the header sits at [-54, 0]). Rather than decode
     that, the bar parks at whatever the header's bottom edge actually is
     this frame: under it when it is showing, at the top of the screen when
     it is not.

     And z-index 90, BELOW the header's 99. At 900 the bar painted straight
     over the header as it slid back in, which is what made the header look
     like it was appearing underneath the filter. */
  RBM.onMobile('coll-stickybar', function () {
    var actions = document.querySelector('.collection-main__actions');
    var header = document.querySelector('header#top.js-header') || document.querySelector('header');
    if (!actions || actions.dataset.rbmStick === '1') return;
    actions.dataset.rbmStick = '1';

    /* The count belongs above the sticky row, not inside it. */
    var count = actions.querySelector('.rbm-count');
    if (count) actions.parentNode.insertBefore(count, actions);

    actions.classList.add('rbm-sticky-actions');
    if (!header) return;

    /* FIXED, NOT STICKY -- AND THIS IS NOT A PREFERENCE.
       Klaviyo puts .klaviyo-prevent-body-scrolling on <body> while you
       scroll UP, which sets overflow:hidden, and any ancestor with
       non-visible overflow disables position:sticky outright. Measured:
       scrolling down, body overflow visible, bar pinned at 54; scrolling up,
       body overflow hidden, bar at -890 -- gone. Removing their class is a
       race against their own scroll handler, and it is their scroll lock to
       own anyway. position:fixed does not care what any ancestor does.

       The cost of fixed is that the element leaves the flow, so a
       placeholder holds its space and prevents the grid jumping up by 63px
       at the moment it pins. */
    var ph = document.createElement('div');
    ph.className = 'rbm-actions-ph';
    actions.parentNode.insertBefore(ph, actions);

    var pinned = false;
    var lastTop = -1;
    var queued = false;

    function place() {
      queued = false;
      if (!document.body.contains(actions)) return;   /* replaced by a filter re-render; the rerun pins the new one */
      var top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      var shouldPin = ph.getBoundingClientRect().top <= top;

      if (shouldPin !== pinned) {
        pinned = shouldPin;
        actions.classList.toggle('rbm-pinned', pinned);
        /* Measure the height BEFORE pinning, while it is still in flow. */
        ph.style.height = pinned ? actions.offsetHeight + 'px' : '';
      }
      if (pinned && top !== lastTop) {
        lastTop = top;
        actions.style.top = top + 'px';
      }
      /* The header keeps sliding (a ~300ms transform transition) AFTER the
         last scroll event, so a bar placed only on scroll was left parked
         at the header's mid-slide bottom edge -- ~90px down, products
         showing in the gap above it (Mark, 22 Sep, twice). Keep following
         the header for a moment after scrolling stops. */
      if (performance.now() < settleUntil) { queued = true; requestAnimationFrame(place); }
    }
    var settleUntil = 0;
    function onScroll() {
      settleUntil = performance.now() + 1200;   /* header starts ~250ms after the last scroll event, done by ~550 */
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    }
    place();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  });

  /* ---- quick filters on the bar ---------------------------------------------
     Straight from J.Crew's mobile PLP, which is the closest comparable by
     catalog size: their sticky bar is not one button, it is
     "ALL FILTERS >" followed by the two attributes people actually reach for
     ("Fabric >", "Sleeve Length >"). One tap lands you in the right group
     instead of opening a panel and hunting.

     Here that is Size and Brand. Size because it is the buying filter; Brand
     because this is a multi-brand retailer, which is exactly where Rooster
     differs from a single-label shop like J.Crew.

     The groups are <details> elements, so revealing one is just .open = true
     -- no need to simulate a click on the theme's accordion. The panel is
     opened through the theme's own trigger, so its scroll lock, focus trap
     and close button all keep working. */
  var QUICK = [/^size\b/i, /^brand\b/i];

  RBM.onMobile('coll-quickfilters', function () {
    var bar = document.querySelector('.collection-main__filter');
    var side = document.querySelector('.collection-sidebar');
    if (!bar || !side || bar.dataset.rbmChips === '1') return;
    var trigger = bar.querySelector('.js-collection-draw-trigger');
    if (!trigger) return;

    var groups = side.querySelectorAll('.collection-sidebar__filter-group');
    if (!groups.length) return;

    QUICK.forEach(function (rx) {
      var group = Array.prototype.filter.call(groups, function (g) {
        var s = g.querySelector('summary');
        return rx.test((s ? s.textContent : '').trim());
      })[0];
      if (!group) return;
      var label = (group.querySelector('summary').textContent || '').trim().split('\n')[0];

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rbm-fchip';
      chip.textContent = label;

      chip.addEventListener('click', function () {
        trigger.click();
        /* The panel animates in, so the group has no box to scroll to yet.
           Poll briefly rather than guess at the animation length. */
        var tries = 0;
        (function reveal() {
          tries++;
          if (group.getBoundingClientRect().height > 0) {
            group.open = true;
            group.scrollIntoView({ block: 'start', behavior: 'smooth' });
          } else if (tries < 25) {
            setTimeout(reveal, 80);
          }
        })();
      });

      bar.appendChild(chip);
    });

    bar.dataset.rbmChips = '1';
  });

  /* ---- how many products am I even looking at? ------------------------------
     The collection page never says. The only place the number appears is the
     "View (688)" button inside the closed filter panel, so it is read from
     there and put on the page, where it answers "is this 40 shirts or 700"
     before anyone starts scrolling. Once Load more is in play it doubles as
     progress: "96 of 688". */
  RBM.onMobile('coll-total', function () {
    var bar = document.querySelector('.collection-main__filter');
    if (!bar) return;
    if (document.querySelector('.rbm-count')) { paintTotal(); setTimeout(paintTotal, 900); return; }
    if (!totalCount()) return;
    var line = document.createElement('div');
    line.className = 'rbm-count';
    /* Anchored to .collection-main__actions, NOT to the bar. Inserting
       before the bar puts it INSIDE actions, which is the element that pins
       -- measured: the pinned block came out 104px instead of 73px, carrying
       the count down the page with it. coll-stickybar lifts a count it finds,
       but it runs before this does, so the anchor has to be right here. */
    var actions = document.querySelector('.collection-main__actions') || bar;
    actions.parentNode.insertBefore(line, actions);
    paintTotal();
    /* the theme hides sold-out-in-your-size cards a beat after render */
    setTimeout(paintTotal, 900); setTimeout(paintTotal, 2500);
  });

  /* ---- load more ------------------------------------------------------------
     Numbered pagination is a desktop control: 15 tiny page links, of which
     the only one most people want is "next", and every tap is a full page
     load that throws away your scroll position. Outerknown (the closest
     comparable running Shopify) uses Load More; J.Crew still uses Next page.
     On a collection page whose whole job is showing product, appending beats
     navigating.

     THE PAGINATION LINKS ARE NOT DELETED. They are visually hidden but left
     in the DOM and in the accessibility tree, so crawlers still have a path
     through every page of the collection -- this is a presentation change,
     not a change to how the collection is indexed.

     The next page is fetched as HTML and its cards are moved across. Nothing
     is re-implemented: the markup comes from the same template that rendered
     page 1, and the theme's custom elements (product-card-swatches and
     friends) upgrade themselves when inserted. Verified on the preview:
     48 -> 96 -> 144, swatches upgraded, quick-add still a 44px target on an
     appended card. */
  function totalCount() {
    var view = Array.prototype.filter.call(
      document.querySelectorAll('.collection-sidebar a.c-btn, .collection-sidebar button.c-btn'),
      function (b) { return /^view\s*\(/i.test((b.textContent || '').trim()); })[0];
    var m = view && (view.textContent || '').match(/\(([\d,]+)\)/);
    return m ? m[1] : null;
  }

  /* Cards the theme renders but hides: a size filter matches a product on a
     size that is sold out, and the theme's "sold out in your size" rule hides
     the card (is-out-of-stock-for-size, display:none). Shopify's facet still
     counts it, so /collections/sale?size=12 said "1 of 1 products" over an
     empty grid (Mark, 23 Sep). Count what can be SEEN, and say why when that
     is nothing. */
  function visibleCards() {
    return Array.prototype.filter.call(document.querySelectorAll('.collection-products .product-card'), function (c) {
      var item = c.closest('.o-layout__item') || c;
      return !(item.classList.contains('is-out-of-stock-for-size') || item.style.display === 'none' || getComputedStyle(item).display === 'none');
    }).length;
  }
  function paintEmpty() {
    var grid = document.querySelector('.collection__cards');
    var old = document.querySelector('.rbm-empty');
    if (!grid) { if (old) old.parentNode.removeChild(old); return; }
    var all = document.querySelectorAll('.collection-products .product-card').length;
    if (all && !visibleCards()) {
      var sizes = Array.prototype.map.call(document.querySelectorAll('.collection__filters-active .js-active-filter-chip[data-filter-label="size"]'), function (a) { return (a.getAttribute('data-filter-value') || a.textContent).trim(); });
      if (!old) { old = document.createElement('div'); old.className = 'rbm-empty'; grid.parentNode.insertBefore(old, grid); }
      old.innerHTML = '<p>' + (sizes.length ? 'Nothing in stock in size ' + sizes.map(function (x) { return '<b>' + x.replace(/[<>&]/g, '') + '</b>'; }).join(', ') + ' here.' : 'Nothing in stock for that filter.') + '</p>' +
        '<p class="rbm-empty__sub">The matching pieces are sold out in that size.</p>' +
        (document.querySelector('.collection__filters-active a[href]') ? '<button type="button" class="rbm-empty__clear">Clear filters</button>' : '');
      var btn = old.querySelector('.rbm-empty__clear');
      if (btn) btn.addEventListener('click', function () { var clear = Array.prototype.filter.call(document.querySelectorAll('.collection__filters-active a'), function (a) { return /clear/i.test(a.textContent); })[0] || document.querySelector('.collection__filters-active a'); if (clear) clear.click(); });
    } else if (old) old.parentNode.removeChild(old);
  }

  function paintTotal() {
    var line = document.querySelector('.rbm-count');
    if (!line) return;
    var total = totalCount();
    var shown = visibleCards();
    line.textContent = total ? (shown + ' of ' + total + ' products') : (shown + ' products');
    paintEmpty();
  }

  RBM.onMobile('coll-loadmore', function () {
    var pag = document.querySelector('.collection-pagination');
    var grid = document.querySelector('.collection__cards');
    if (!pag || !grid || pag.dataset.rbmPag === '1') return;
    pag.dataset.rbmPag = '1';

    var nextA = pag.querySelector('.next a');
    if (!nextA) return;                       /* single page: nothing to add */
    var nextHref = nextA.getAttribute('href');

    pag.classList.add('rbm-pag-hidden');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rbm-loadmore';
    btn.textContent = 'Load more';
    pag.parentNode.insertBefore(btn, pag);

    btn.addEventListener('click', function () {
      if (btn.disabled || !nextHref) return;
      btn.disabled = true;
      btn.textContent = 'Loading...';

      fetch(nextHref, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var more = doc.querySelector('.collection__cards');
          if (!more) throw new Error('no grid');

          /* Moving nodes between documents needs an explicit import, and
             appending one at a time keeps the custom elements upgrading in
             document order. */
          var added = 0;
          Array.prototype.forEach.call(more.children, function (item) {
            grid.appendChild(document.importNode(item, true));
            added++;
          });

          var nA = doc.querySelector('.collection-pagination .next a');
          nextHref = nA ? nA.getAttribute('href') : null;

          paintTotal();
          paintSwatches();

          if (nextHref) {
            btn.disabled = false;
            btn.textContent = 'Load more';
          } else {
            btn.parentNode.removeChild(btn);
            /* Last page reached -- there is nothing left to link to, so the
               hidden pager can stay hidden. */
          }
          if (!added) btn.textContent = 'Load more';
        })
        .catch(function () {
          /* Anything unexpected and the reader gets the real pager back
             rather than a dead button. */
          pag.classList.remove('rbm-pag-hidden');
          if (btn.parentNode) btn.parentNode.removeChild(btn);
        });
    });
  });

  /* ---- swatch overflow ------------------------------------------------------
     The swatch row is capped to one line in CSS so a five-colour product does
     not add a second row to every card in the grid. Capping alone would hide
     colours silently, so the ones that do not fit are counted: "+2". J.Crew
     does the same thing on their mobile grid.

     Measured rather than assumed, and measured HORIZONTALLY: the row is
     flex-wrap:nowrap, so the extras run off the side rather than wrapping to
     a second line. Comparing offsetTop would find nothing. What counts as
     hidden is a swatch whose right edge sits past the card's right edge,
     with room reserved for the "+n" itself. */
  function paintSwatches(sel) {
    /* sel: desktop also caps the homepage rails (rb-d-coll.js); phones pass nothing */
    var wraps = document.querySelectorAll(typeof sel === 'string' ? sel : '.collection-products .swatch-wrapper');
    Array.prototype.forEach.call(wraps, function (w) {
      /* Idempotent: undo the previous pass first. A pass that ran before the
         card CSS settled hid swatches that fit (Palma Linen showed one swatch
         and "+1" with room for three), so this is re-run late. */
      var old = w.querySelector('.rbm-swatch-more'); if (old) old.parentNode.removeChild(old);
      var items = w.querySelectorAll('.product-card__swatch__item');
      Array.prototype.forEach.call(items, function (li) { if (li.dataset.rbmHid) { li.style.display = ''; delete li.dataset.rbmHid; } });
      if (items.length < 2) { w.dataset.rbmSw = '1'; return; }
      var wr = w.getBoundingClientRect();
      if (!wr.width) return;                          /* not laid out yet */
      var edge = wr.right - 26;  /* room for "+n" */
      var hidden = 0;
      Array.prototype.forEach.call(items, function (li) {
        var r = li.getBoundingClientRect();
        if (r.width && r.right > edge) { hidden++; li.style.display = 'none'; li.dataset.rbmHid = '1'; }
      });
      if (hidden) {
        var more = document.createElement('span');
        more.className = 'rbm-swatch-more';
        more.textContent = '+' + hidden;
        w.appendChild(more);
      }
      w.dataset.rbmSw = '1';
    });
  }

  RBM.onMobile('coll-swatches', function () {
    if (!document.querySelector('.collection-products')) return;
    paintSwatches();
    window.addEventListener('load', function () { setTimeout(paintSwatches, 300); });
    setTimeout(paintSwatches, 2500);
    var grid = document.querySelector('.collection-products');
    if (grid && RBM.onSectionSwap) RBM.onSectionSwap(grid, paintSwatches);
  });

  /* ---- SEO block ------------------------------------------------------------
     1,741px of copy after the last product, on every collection page. It is
     there for search and it works, so nothing is removed and nothing is
     moved out of the DOM -- it is collapsed to a readable opening with a
     toggle, which leaves the markup Google reads completely unchanged.

     The button is built here rather than shipped in the template because the
     template is main-collection-product-grid.liquid at 89KB. */
  RBM.onMobile('coll-seo', function () {
    var sec = document.querySelector('.rb-seo-bottom-section');
    if (!sec || sec.dataset.rbmSeo === '1') return;
    /* Only worth collapsing if there is meaningfully more than the clamp. */
    if (sec.getBoundingClientRect().height < 320) return;

    sec.classList.add('rbm-seo-collapsed');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rbm-seo-toggle';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      var open = sec.classList.toggle('rbm-seo-collapsed') === false;
      btn.textContent = open ? 'Show less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* Collapsing from the bottom of a long block would otherwise leave the
         reader stranded below the fold of a section that just shrank. */
      if (!open) sec.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    sec.parentNode.insertBefore(btn, sec.nextSibling);
    sec.dataset.rbmSeo = '1';
  });

  /* ---- card meta row: stars win (22 Sep) ----------------------------------------
     Judge.me renders its badge after load, so this is a live check, not a
     CSS :has(). A card whose badge has a rating gets .rbm-has-stars and
     rb-m-coll.css shows its stars row (hidden otherwise). */
  RBM.onMobile('card-meta', function () {
    function apply() {
      Array.prototype.forEach.call(document.querySelectorAll('.product-card'), function (card) {
        /* Judge.me's badge is server-rendered with data-number-of-reviews and
           style=display:none until its script shows it (which may be late,
           or blocked). Decide on the DATA, not on the box. */
        var badge = card.querySelector('.jdgm-prev-badge');
        var n = badge ? parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10) : 0;
        var rb = card.querySelector('[class*="rb-review"]');
        var has = n > 0 || (!!rb && /\d/.test(rb.textContent));
        card.classList.toggle('rbm-has-stars', has);
        if (has && badge) badge.style.display = '';   /* show it now; do not wait for jdgm */
      });
    }
    apply();
    setTimeout(apply, 1500); setTimeout(apply, 4000);
    if (window.MutationObserver) new MutationObserver(RBM.debounce(apply, 250)).observe(document.body, { childList: true, subtree: true });
  });

  /* ---- filters only offer what is in stock (Mark, 23 Sep) -------------------
     "Sold-out products should never be filter-selectable." Shopify's size
     facet offers a value if any product HAS a variant with it, in stock or
     not; and filter.v.availability does not combine on the same variant
     (verified: Sale ?size=11&availability=1 returned a shoe whose 11 is sold
     out and whose 13 is in stock). The phone cannot work it out either --
     Shirts is 4 MB of products.json. So the in-stock size set per collection
     is computed server-side by the Bulk Editor's instock_sizes.py, written to
     collection.metafields.custom.instock_sizes, printed by rb-m-include.liquid
     as #rbm-instock-sizes, and used here to GREY OUT (disable, not hide -- Mark)
     every other size option, and the waist/inseam select options with
     nothing behind them. A checked value is never disabled. Re-applied after each filter re-render. */
  var instockSizes = null;
  function readInstock() {
    if (instockSizes) return instockSizes;
    var el = document.getElementById('rbm-instock-sizes');
    if (!el) return null;
    try { var arr = JSON.parse(el.textContent || '[]'); } catch (e) { return null; }
    if (!Array.isArray(arr) || !arr.length) return null;   /* empty = unknown (e.g. Denim Fits, whose parents carry no sizes) -- prune nothing */
    instockSizes = {}; arr.forEach(function (v) { instockSizes[String(v).trim()] = true; });
    return instockSizes;
  }
  function applyInstock() {
    var set = readInstock(); if (!set) return;
    Array.prototype.forEach.call(document.querySelectorAll('.collection-sidebar input[name="filter.v.option.size"]'), function (inp) {
      var li = inp.closest('.collection-sidebar__item'); if (!li) return;
      var out = !(set[inp.value.trim()] || inp.checked);
      li.classList.toggle('rbm-nostock', out);
      inp.disabled = out;                       /* shown, greyed, not selectable (Mark: don't hide) */
      if (out) li.setAttribute('title', 'Sold out in this size'); else li.removeAttribute('title');
    });
    var waists = {}, inseams = {};
    Object.keys(set).forEach(function (v) { var m = v.match(/^(\d{2})\s*(?:x\s*(\d{2}))?$/i); if (m) { waists[m[1]] = true; if (m[2]) inseams[m[2]] = true; } });
    Array.prototype.forEach.call(document.querySelectorAll('.rbb-pants select'), function (sel) {
      var isWaist = /waist/i.test(sel.getAttribute('aria-label') || '');
      Array.prototype.forEach.call(sel.options, function (o) { if (!o.value || o.selected) return; var ok = isWaist ? waists[o.value] : inseams[o.value]; o.disabled = !ok; if (!ok && !/sold out/.test(o.textContent)) o.textContent = o.value + ' \u2014 sold out'; });
    });
  }
  RBM.onMobile('coll-instock', function () {
    applyInstock();
    /* the desktop filter code (rbb-*) regroups the size list a beat after load */
    setTimeout(applyInstock, 600); setTimeout(applyInstock, 2000);
  });

  /* ---- brand search box (Mark, 23 Sep) --------------------------------------
     The Brand group lists 100 vendors (Shopify's facet cap) as a plain
     checkbox column -- on a phone that is ~20 screens of scrolling to reach
     "Vuori". A type-to-filter box goes at the top of the group; typing hides
     every row whose label does not contain the text. Nothing is fetched and
     no checkbox state is touched, so a brand ticked earlier stays ticked even
     while filtered out of view.

     The group is replaced on every filter change (see coll-rerun), so the
     query lives here in the module and is re-applied to the new list. Enter
     is swallowed: the inputs sit inside the theme's filter <form>, and Enter
     in a text field would submit it. */
  var brandQuery = '';
  function brandGroup() {
    return Array.prototype.filter.call(document.querySelectorAll('.collection-sidebar__filter-group'), function (g) {
      var s = g.querySelector('summary');
      return /^brand\b/i.test((s ? s.textContent : '').trim());
    })[0] || null;
  }
  function applyBrandFind(grp) {
    var rows = grp.querySelectorAll('.collection-sidebar__item');
    var q = brandQuery.trim().toLowerCase();
    var shown = 0;
    Array.prototype.forEach.call(rows, function (li) {
      var lab = li.querySelector('.js-filter-label') || li;
      var hit = !q || (lab.textContent || '').toLowerCase().indexOf(q) !== -1;
      li.classList.toggle('rbm-find-hide', !hit);
      if (hit) shown++;
    });
    var none = grp.querySelector('.rbm-find__none');
    if (none) none.hidden = !(q && !shown);
    var clear = grp.querySelector('.rbm-find__clear');
    if (clear) clear.hidden = !q;
  }
  RBM.onMobile('coll-brandfind', function () {
    var grp = brandGroup();
    if (!grp || grp.querySelector('.rbm-find')) return;
    var body = grp.querySelector('details-content, .collection-sidebar__filter__accordion');
    var list = grp.querySelector('.collection-sidebar__items');
    if (!body || !list || list.children.length < 12) return;   /* short lists do not need a search */

    var wrap = document.createElement('div');
    wrap.className = 'rbm-find';
    wrap.innerHTML =
      '<div class="rbm-find__box">' +
        '<svg class="rbm-find__ico" viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="5.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M12.8 12.8 17 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
        '<input type="text" class="rbm-find__in" placeholder="Search brands" aria-label="Search brands" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="done">' +
        '<button type="button" class="rbm-find__clear" aria-label="Clear brand search" hidden>&times;</button>' +
      '</div>' +
      /* Shopify lists at most 100 brand values per collection (by count), so a
         real brand can be absent here -- "Vuori" on Shop All. Point at the
         brand directory rather than leaving a dead end. */
      '<p class="rbm-find__none" hidden>No brands match in this collection. <a href="/pages/brands">All brands &rarr;</a></p>';
    body.insertBefore(wrap, list);

    var inp = wrap.querySelector('.rbm-find__in');
    inp.value = brandQuery;
    inp.addEventListener('input', function () { brandQuery = inp.value; applyBrandFind(grp); });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); inp.blur(); }
    });
    wrap.querySelector('.rbm-find__clear').addEventListener('click', function () {
      brandQuery = ''; inp.value = ''; applyBrandFind(grp); inp.focus();
    });
    applyBrandFind(grp);
  });

  /* ---- after every filter change, rebuild (23 Sep) --------------------------
     The theme swaps .collection-main wholesale on each filter/sort change.
     The section wrapper itself survives, so it is the thing to watch. Every
     module above keys its work on elements that are now new, so re-running
     them is exactly a first run on the new markup. */
  RBM.onMobile('coll-rerun', function () {
    var sec = document.querySelector('.shopify-section[id*="product-grid"]') || (document.querySelector('.collection-main') || {}).parentElement;
    if (!sec || !RBM.onSectionSwap) return;
    RBM.onSectionSwap(sec, function () {
      RBM.rerun(['coll-count', 'coll-panel', 'coll-stickybar', 'coll-quickfilters', 'coll-total', 'coll-loadmore', 'coll-swatches', 'coll-instock', 'coll-brandfind', 'qa-wash']);
      if (window.scrollY > 0) window.dispatchEvent(new Event('scroll'));   /* let the new bar decide whether to pin */
    });
  });

  /* Shared with the desktop modules (rb-d-coll.js, 23 Sep): these three work
     on the theme's own filter markup, which is the same at every width. */
  RBM.collShared = { applyInstock: applyInstock, paintEmpty: paintEmpty, visibleCards: visibleCards, paintSwatches: paintSwatches };
})();